import {Box, ThemeProvider} from '@primer/react-brand/esm'
import {WebGLPage} from '@github-ui/brand-webgl'
import type {FlexSuiteCategoryPage} from '../types'
import {FlexSuiteHero} from '../components/FlexSuiteHero'
import {FlexSuiteSubNav} from '../components/FlexSuiteSubNav'
import {IndexSection} from './components/IndexSection'
import {IntroSection} from './components/IntroSection'

export type CategoryTemplateProps = {
  page: FlexSuiteCategoryPage
}

export function CategoryTemplate({page}: CategoryTemplateProps) {
  const {template, settings} = page.fields
  const pageColorMode = settings?.fields.colorMode ?? 'light'
  const {
    subNav,
    sectionIntroHeading,
    sectionIntroLabel,
    sectionIntroDescription,
    sectionIntroLink,
    breakoutVariant,
    featureRiverBreakout,
    featureBreakoutTabs,
    cardsVariant,
    cardsIconItems,
    cardsImageItems,
    indexTestimonialVariant,
    indexTestimonialLink,
    indexTestimonialLogo,
    indexTestimonialQuote,
    indexTestimonialImage,
    indexTestimonialLabel,
    indexTestimonialName,
    indexTestimonialTitle,
    heroHeading,
    heroLabel,
    heroDescription,
    heroVariant,
    heroAsset,
    heroCtaOne,
    heroCtaTwo,
    heroImageCards,
    heroIconCards,
    introLogos,
    introLogoLink,
    introStats,
  } = template.fields

  return (
    <ThemeProvider colorMode={pageColorMode}>
      {/* Keep background synchronized with the current color mode */}
      <Box backgroundColor="default">
        <WebGLPage mode={pageColorMode}>
          {subNav && <FlexSuiteSubNav subNav={subNav} />}
          <FlexSuiteHero
            heroHeading={heroHeading}
            heroLabel={heroLabel}
            heroDescription={heroDescription}
            heroVariant={heroVariant}
            heroAsset={heroAsset}
            heroCtaOne={heroCtaOne}
            heroCtaTwo={heroCtaTwo}
            heroImageCards={heroImageCards}
            heroIconCards={heroIconCards}
            showDither
            options={{
              variant: 'gridline',
              align: 'center',
              enableAnimation: true,
              textVariant: heroVariant === '50/50' ? 'muted' : 'default',
            }}
          />
          <IntroSection
            introLogos={introLogos}
            introLogoLink={introLogoLink}
            introStats={introStats}
            logobarOptions={{marquee: true, marqueeSpeed: 'slow', variant: 'muted'}}
            logoSuiteOptions={{variant: 'gridline-expressive'}}
          />
          <IndexSection
            sectionIntroHeading={sectionIntroHeading}
            sectionIntroLabel={sectionIntroLabel}
            sectionIntroDescription={sectionIntroDescription}
            sectionIntroLink={sectionIntroLink}
            breakoutVariant={breakoutVariant}
            featureRiverBreakout={featureRiverBreakout}
            featureBreakoutTabs={featureBreakoutTabs}
            cardsVariant={cardsVariant}
            cardsIconItems={cardsIconItems}
            cardsImageItems={cardsImageItems}
            indexTestimonialVariant={indexTestimonialVariant}
            indexTestimonialLink={indexTestimonialLink}
            indexTestimonialLogo={indexTestimonialLogo}
            indexTestimonialQuote={indexTestimonialQuote}
            indexTestimonialImage={indexTestimonialImage}
            indexTestimonialLabel={indexTestimonialLabel}
            indexTestimonialName={indexTestimonialName}
            indexTestimonialTitle={indexTestimonialTitle}
          />
        </WebGLPage>
      </Box>
    </ThemeProvider>
  )
}
